import { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { 
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, 
    Button, 
    FormGroup, 
    Label, 
    Input, 
    Spinner
} from 'reactstrap';

function RelevancyReasonModal({ 
    t,
    isOpen, 
    toggle, 
    onSave,
    isLoading
}) {
    const [selectedReason, setSelectedReason] = useState('');
    const [customReason, setCustomReason] = useState('');

    const handleSave = () => {
        if(selectedReason === 'other') {
            onSave({
                relevancy: false,
                reasonType: 'other',
                reasonText: customReason
            })
        }
        else{
            onSave({
                relevancy: false,
                reasonType: '',
                reasonText: selectedReason
            })
        }
    };

    useEffect(() => {
        if(isOpen) {
            setSelectedReason('');
            setCustomReason('');
        }
    }, [ isOpen ]);

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('Select Reason for Marking as Not Relevant')}
            </ModalHeader>

            <ModalBody>
                <FormGroup>
                    <Label for="reason-select">
                        {t('Reason')}
                    </Label>
                    <Input
                        type="select"
                        id="reason-select"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                    >
                        <option value="">
                            {t('Select a reason')}...
                        </option>
                        <option
                            value='Out of Scope'
                        >
                            {t('Out of Scope')}
                        </option>
                        <option
                            value='Already Known'
                        >
                            {t('Already Known')}
                        </option>
                        <option
                            value='other'
                        >
                            {t('Other')}
                        </option>
                    </Input>
                </FormGroup>
                {selectedReason === 'other' && (
                    <FormGroup className='mt-3'>
                        <Label for="custom-reason">
                            {t('Custom Reason')}
                        </Label>
                        <Input
                            type="text"
                            id="custom-reason"
                            placeholder={`${t('Enter your reason')}...`}
                            value={customReason}
                            onChange={(e) => setCustomReason(e.target.value)}
                        />
                    </FormGroup>
                )}
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="primary" 
                    onClick={handleSave}
                    disabled={isLoading || (!selectedReason || (selectedReason === 'other' && !customReason))}
                >
                    {isLoading && <Spinner size="sm" className="me-2" />}
                    {t('Save')}
                </Button>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default withNamespaces()(
    RelevancyReasonModal
);